import React, { useEffect, useMemo } from 'react';

import { v4 as uuidv4 } from 'uuid';
import { useGlobalLoading } from './useGlobalLoading';
import { GlobalLoadingCallerProps, Content } from './GlobalLoadingCaller.models';

const createContentDependencyArray = (content?: Content) => {
  const component = content?.Component;

  // SimpleMessageLoading content props
  const title = content?.props?.title;
  const description = content?.props?.description;
  const simpleMessageLoadingProps = [title, description];

  // For new components props create newProps = [prop1, prop2]; and spread the array at the end

  return [component, ...simpleMessageLoadingProps];
};

export const GlobalLoadingCaller: React.FC<GlobalLoadingCallerProps> = ({ queryKey, content }) => {
  const { startLoading, setContent } = useGlobalLoading(queryKey);

  const dependencyArray = Array.isArray(queryKey) ? queryKey : [queryKey];
  const loadingId = useMemo(() => (
    queryKey ?? [uuidv4()]
  ), dependencyArray);

  const stringLoadingId = loadingId?.join();

  useEffect(() => {
    startLoading();
  }, []);

  const contentDependencyArray = createContentDependencyArray(content);

  useEffect(() => {
    setContent(content);
  }, contentDependencyArray);

  return <React.Fragment key={stringLoadingId} />;
};
